// Copyright © Veeam Software Group GmbH

export enum StubPaths {
  NoMatch = 'NoMatch',
}
